export default __webpack_public_path__ + "static/media/you dont know react.815f880e.png";